import React, { useContext } from 'react';
import './Login.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GLOBAL_CONTEXT } from 'mmbclient/Common/CommonVariable'
import 'mmbclient/Common/GlobalVariable';
import LinearProgress from '@material-ui/core/LinearProgress';
import LoginController from 'mmbclient/Login/LoginController'

const Login = () => {

    const store = useContext(GLOBAL_CONTEXT);

    const { username, setUserName, password, setPassword, userType, handleChangeUser, showProgressBar, checkLogin } = LoginController(store);

    return (
        <>
            <div>
                <div className="login-root">
                    <div className="box-root flex-flex flex-direction--column" style={{ minHeight: "100vh", flexGrow: 1 }}>
                        <div className="loginbackground box-background--white padding-top--64">
                            <div className="loginbackground-gridContainer">
                                <div className="box-root flex-flex div1">
                                    <div className="box-root div2">
                                    </div>
                                </div>
                                <div className="box-root flex-flex div3">
                                    <div className="box-root box-divider--light-all-2 animationLeftRight tans3s" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div4">
                                    <div className="box-root box-background--blue800" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div5">
                                    <div className="box-root box-background--blue animationLeftRight" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div6">
                                    <div className="box-root box-background--gray100 animationLeftRight tans3s" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div7">
                                    <div className="box-root box-background--cyan200 animationRightLeft tans4s" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div8">
                                    <div className="box-root box-background--blue animationRightLeft" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div9">
                                    <div className="box-root box-background--gray100 animationRightLeft tans4s" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                                <div className="box-root flex-flex div10">
                                    <div className="box-root box-divider--light-all-2 animationRightLeft tans3s" style={{ flexGrow: 1, zIndex: 9 }}></div>
                                </div>
                            </div>
                        </div>
                        <div className="box-root padding-top--24 flex-flex flex-direction--column" style={{ flexGrow: 1, zIndex: 9 }}>
                            <div className="box-root padding-top--48 padding-bottom--24 flex-flex flex-justifyContent--center">
                                <h1 style={{ color: "#5469D4", textDecoration: "unset", alignItems: "center" }}>Login</h1>
                            </div>
                            <div className="formbg-outer">
                                <div className="formbg">
                                    {showProgressBar && <LinearProgress />}
                                    <div className="formbg-inner padding-horizontal--48">
                                        <div id="output" style={{ display: "none", backgroundColor: "#cc3300", color: "white", textDecoration: "unset", alignItems: "center" }} className="padding-bottom--15 div12"></div>
                                        <div className="custom02" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                            <input type="radio" checked={userType === 'US'} id="radio03-01" name="userType" value="US" onClick={handleChangeUser} />
                                            <label htmlFor="radio03-01">Customer</label>

                                            <input type="radio" checked={userType === 'AD'} id="radio03-02" name="userType" value="AD" onClick={handleChangeUser} />
                                            <label htmlFor="radio03-02">Admin</label>

                                            <input type="radio" checked={userType === 'EP'} id="radio03-03" name="userType" value="EP" onClick={handleChangeUser} />
                                            <label htmlFor="radio03-03">Employee</label>
                                        </div>
                                        <span className="padding-bottom--15 div11">Sign in to your account</span>
                                        <form id="stripe-login" autoComplete='off'>
                                            <div className="field padding-bottom--24">
                                                <label htmlFor="username">Username</label>
                                                <input type="text" name="username" id="username" autoComplete="off" value={username} onChange={(e) => setUserName(e.target.value)} />
                                            </div>
                                            <div className="field padding-bottom--24">
                                                <div className="grid--50-50">
                                                    <label htmlFor="password">Password</label>
                                                    {/* <div className="reset-pass">
                                                    <a href="#">Forgot your password?</a>
                                                </div> */}
                                                </div>
                                                <input type="password" name="password" id="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                            </div>
                                            {/* <div className="field field-checkbox padding-bottom--24 flex-flex align-center">
                                            <label htmlFor="checkbox">
                                                <input type="checkbox" name="checkbox" /> Stay signed in for a week
                                            </label>
                                        </div> */}
                                            <div className="field padding-bottom--24">
                                                <input type="submit" name="submit" value="Continue" onClick={(e) => { checkLogin(e) }} />
                                            </div>
                                            {/* <div className="field">
                                            <a className="ssolink" href="#">Use single sign-on (Google) instead</a>
                                        </div> */}
                                        </form>
                                    </div>
                                </div>
                                <div className="footer-link padding-top--24">
                                    <span className="div11">Don't have an account? Contact Admin.</span>
                                    {/* <div className="listing padding-top--24 padding-bottom--24 flex-flex center-center">
                                    <span className="div11"><a href="#">© Stackfindover</a></span>
                                    <span className="div11"><a href="#">Contact</a></span>
                                    <span className="div11"><a href="#">Privacy & terms</a></span>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    )
}

export default Login
